import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import './style.css.scss'

const ANIMATION_DURATION = 1000

class ScrollableTabs extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isDisabledRight: false,
      isDisabledLeft: true,
      isShowArrows: true,
      currentSection: 0
    }
  }

  componentDidMount () {
    this.tabsContainer = this.scrollContainer.children[0]
    this.sectionsArray = this.getSectionsArray()
    this.setCurrentSection()

    this.addChildrenEventListener()

    this.setState({
      isShowArrows: this.sectionsArray.length > 1
    })
  }

  addChildrenEventListener = () => {
    const childrenElementArray = Array.from(this.tabsContainer.children)
    childrenElementArray.forEach((childElement)=>{
      childElement.addEventListener('click',this.handleElementClick)
    })
  }

  getElementsWidthArray() {
    return Array.from(this.tabsContainer.children).map(element =>(element.offsetWidth))
  }

  setCurrentSection = () => {
    const currentSection = this.sectionsArray.findIndex((element) => { 
      return (this.props.selectedElementIndex <= element.lastIndex)
    })

    if (currentSection == 0) {
      return 
    }

    this.scrollRight(currentSection - 1)
  }

  getSectionsArray = () => {
    // return array of sections which contains the max items per scroller width.
    const elementsWidthArray = this.getElementsWidthArray()

    let currentSectionWidth = 0,
      totalWidth = 0,
      index = 0,
      sectionsArray = [],
      prev = null,
      next = 0,
      currentPosition = 0;

    while (index <= (elementsWidthArray.length - 1)) {
      currentSectionWidth += elementsWidthArray[index] + this.props.padding
      if (currentSectionWidth + elementsWidthArray[index + 1] + this.props.padding > this.scrollContainer.offsetWidth) {
        // in case the sum of the current elements' width is the maximum size which can fit to the scroller width
        currentPosition = totalWidth
        totalWidth += currentSectionWidth
        sectionsArray.push({
          next: totalWidth, 
          prev, 
          lastIndex: index,
          currentPosition
        }) 

        prev = (prev === null) ? 0 : currentPosition
        currentSectionWidth = 0
      } 
      
      if (index === (elementsWidthArray.length - 1)) {
        // in case it's the last section
        sectionsArray.push({
          next:null, 
          prev, 
          lastIndex: index,
          currentPosition: totalWidth})
      }

      index++
    }
    return sectionsArray
    /*
    EXAMPLE
    sectionArray = [
      {next: 797, prev: null, lastIndex: 5, currentPosition: 0},
      {next: 1610, prev: 0, lastIndex: 14, currentPosition: 797},
      {next: null, prev: 797, lastIndex: 18, currentPosition: 1610}
    ]
    */
  }
 
  getEaseInOutAnimationStep = (time, position, distance, duration) => {
    time /= duration/2;
    if (time < 1) {
      return distance/2*time*time + position
    } 
    time--
    return -distance/2 * (time*(time-2) - 1) + position
  }

  scrollTo = (element, endPosition, duration = ANIMATION_DURATION) => {
    let currentPosition = element.scrollLeft,
      distance = endPosition - currentPosition,
      currentTime = 0,
      increment = 10

    this.setState ({currentPosition: endPosition})

    const animateScroll = () => {
      currentTime += increment
      const step = this.getEaseInOutAnimationStep(currentTime, currentPosition, distance, duration)
      element.scrollLeft = step
     
      if(currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }
    animateScroll();
  }

  scrollRight = (currentSection) => {
    if (this.state.currentPosition && this.state.currentPosition < this.sectionsArray[currentSection].currentPosition) {
      //in case there is an offset, return to original position
      this.scrollTo(this.tabsContainer, this.sectionsArray[currentSection].currentPosition)
      this.setState({
        isDisabledRight: (this.sectionsArray[currentSection].next === null)
      }) 
    } 
    else {
      this.scrollTo(this.tabsContainer,this.sectionsArray[currentSection].next)
      this.setState({
        isDisabledLeft: false, 
        isDisabledRight: (this.sectionsArray[currentSection + 1].next === null),
        currentSection: currentSection + 1
      })
    }
  }

  scrollLeft = (currentSection) => {
    if (this.state.currentPosition && this.state.currentPosition > this.sectionsArray[currentSection].currentPosition) {
      //in case there is an offset, return to original position
      this.scrollTo(this.tabsContainer, this.sectionsArray[currentSection].currentPosition)
      this.setState({
        isDisabledLeft: (this.sectionsArray[currentSection].prev === null)
      }) 
    } 
    else {
      this.scrollTo(this.tabsContainer,this.sectionsArray[currentSection].prev)
      this.setState({
        currentSection: (currentSection - 1),
        isDisabledLeft: (this.sectionsArray[currentSection - 1].prev === null),
        isDisabledRight: false
      }) 
    }
  }

  handleClickRight = () => {
    if (this.state.isDisabledRight) {
      return
    }
    this.scrollRight(this.state.currentSection)
  }

  handleClickLeft = () => {
    if (this.state.isDisabledLeft) {
      return
    }
    this.scrollLeft(this.state.currentSection)
  }

  getDirectChildOfElement = (e) => {
    return e.path[e.path.indexOf(this.tabsContainer) - 1]
  }

  handleElementClick = (e) => {
    const el = this.getDirectChildOfElement(e)
    let dist

    // calculate if there is an overflow element
    const scrollerLeftGap = el.getBoundingClientRect().left - el.parentElement.getBoundingClientRect().left
    const scrollertRightGap = el.parentElement.getBoundingClientRect().right - el.getBoundingClientRect().right
    if (scrollertRightGap < 0) {
      //right element is overflow
      dist = this.tabsContainer.scrollLeft + Math.abs(scrollertRightGap) + this.props.padding
      this.scrollTo(this.tabsContainer,dist)
      this.setState({isDisabledLeft: false})
    } 
    else if (scrollerLeftGap < 0) {
      //left element is overflow
      dist = this.tabsContainer.scrollLeft + scrollerLeftGap - this.props.padding
      this.scrollTo(this.tabsContainer,dist)
      this.setState({isDisabledRight: false})
    }
  }

  render() { 
    return (
      <div className="scrollable-tabs">
        
        {this.state.isShowArrows && (
          <span 
            style={this.state.isDisabledLeft ? get(this.props.arrowStyle, 'disabled' ,{}) : get(this.props.arrowStyle, 'enabled' ,{})}
            onClick={this.handleClickLeft}
            className={`arrow icon-chevron-left-thick ${this.state.isDisabledLeft ? 'disabled' : ''}`}/>
        )}

        <div className={`tabs-container ${this.state.isShowArrows ? 'show-arrows' : ''}`}
          ref={ref => this.scrollContainer = ref}>
          {this.props.children}
        </div>

        {this.state.isShowArrows && (
          <span
            style={this.state.isDisabledRight ? get(this.props.arrowStyle, 'disabled' ,{}) : get(this.props.arrowStyle, 'enabled' ,{})}
            onClick={this.handleClickRight}
            className={`arrow icon-chevron-right-thick ${this.state.isDisabledRight ? 'disabled' : ''}`}/>
        )}

      </div>
    )
  }
}

ScrollableTabs.propTypes = {
  selectedElementIndex: PropTypes.number,
  padding: PropTypes.number,
  arrowStyle: PropTypes.object
}

ScrollableTabs.defaultProps = {
  selectedElementIndex: 0,
  padding: 0,
  arrowStyle:{}
}

export default ScrollableTabs
